import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Lead } from "../../types";

interface LeadDetailsFormProps {
  editedLead: Lead;
  handleInputChange: (field: keyof Lead, value: string | number) => void;
}

export const LeadDetailsForm = ({ editedLead, handleInputChange }: LeadDetailsFormProps) => {
  return (
    <div className="grid gap-4 py-4">
      <div className="grid grid-cols-2 gap-4">
        <Input
          placeholder="First Name"
          value={editedLead.first_name}
          onChange={(e) => handleInputChange("first_name", e.target.value)}
        />
        <Input
          placeholder="Last Name"
          value={editedLead.last_name}
          onChange={(e) => handleInputChange("last_name", e.target.value)}
        />
      </div>
      
      <Input
        placeholder="Email"
        type="email"
        value={editedLead.email}
        onChange={(e) => handleInputChange("email", e.target.value)}
      />
      
      <Input
        placeholder="Phone"
        value={editedLead.phone}
        onChange={(e) => handleInputChange("phone", e.target.value)}
      />

      <Input
        placeholder="Street Address"
        value={editedLead.street}
        onChange={(e) => handleInputChange("street", e.target.value)}
      />

      <div className="grid grid-cols-3 gap-4">
        <Input
          placeholder="City"
          value={editedLead.city}
          onChange={(e) => handleInputChange("city", e.target.value)}
        />
        <Input
          placeholder="State"
          value={editedLead.state}
          onChange={(e) => handleInputChange("state", e.target.value)}
        />
        <Input
          placeholder="ZIP Code"
          value={editedLead.zip_code}
          onChange={(e) => handleInputChange("zip_code", e.target.value)}
        />
      </div>
      
      <Select
        value={editedLead.insurance_type}
        onValueChange={(value) => handleInputChange("insurance_type", value)}
      >
        <SelectTrigger>
          <SelectValue placeholder="Insurance Type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="Auto">Auto Insurance</SelectItem>
          <SelectItem value="Home">Home Insurance</SelectItem>
          <SelectItem value="Life">Life Insurance</SelectItem>
          <SelectItem value="Business">Business Insurance</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={editedLead.lead_source}
        onValueChange={(value) => handleInputChange("lead_source", value)}
      >
        <SelectTrigger>
          <SelectValue placeholder="Lead Source" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="Website">Website</SelectItem>
          <SelectItem value="Referral">Referral</SelectItem>
          <SelectItem value="Social Media">Social Media</SelectItem>
          <SelectItem value="Manual Entry">Manual Entry</SelectItem>
        </SelectContent>
      </Select>

      <Input
        type="number"
        placeholder="Quoted Amount"
        value={editedLead.quoted_amount}
        onChange={(e) => handleInputChange("quoted_amount", Number(e.target.value))}
      />
    </div>
  );
};